import { render, staticRenderFns } from "./InboundDeliveryCreate.vue?vue&type=template&id=7274fb58&scoped=true&"
import script from "./InboundDeliveryCreate.vue?vue&type=script&lang=js&"
export * from "./InboundDeliveryCreate.vue?vue&type=script&lang=js&"
import style0 from "./InboundDeliveryCreate.vue?vue&type=style&index=0&id=7274fb58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7274fb58",
  null
  
)

export default component.exports